var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b08ba1d9-cc46-418b-a54c-c7555cff3d45",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b74ca772-1d3c-45c6-b4af-ce37b2c4a1ec",
    d: "M64,25.25A46.75,46.75,0,1,0,110.75,72,46.8,46.8,0,0,0,64,25.25Zm0,90.5A43.75,43.75,0,1,1,107.75,72,43.8,43.8,0,0,1,64,115.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b74ca772-1d3c-45c6-b4af-ce37b2c4a1ec",
    d: "M90.84,72l-30.3,30.31c-1.08-.13-2.13-.31-3.17-.54L87.15,72H82.91L54.07,100.84c-1-.35-2-.75-3-1.19L78.77,72H74.53L48.35,98.18c-.84-.51-1.66-1.06-2.45-1.64L70.43,72H66.19L43.56,94.63c-.74-.67-1.45-1.38-2.12-2.12L62,71.93h35.4v-3H64.08V38.49l-.08,0v0A33.51,33.51,0,1,0,97.51,72ZM53.68,43.29,35.29,61.68A30.7,30.7,0,0,1,53.68,43.29ZM33.84,67.37,59.37,41.84c.56-.08,1.14-.14,1.71-.2v2.18L33.51,71.4A29.74,29.74,0,0,1,33.84,67.37Zm-.15,8.08L61.08,48.06V51.9L34.25,78.73A31.61,31.61,0,0,1,33.69,75.45ZM35.19,82,61.08,56.14V60L36.31,84.78A28.77,28.77,0,0,1,35.19,82Zm4.33,8.16a30.77,30.77,0,0,1-1.75-2.63L61.08,64.25v4.38Zm35.4,10.29L92.48,82.92A30.68,30.68,0,0,1,74.92,100.48Zm-5.84,1.6a31.48,31.48,0,0,1-4.49.41l29.9-29.9a31.48,31.48,0,0,1-.41,4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b74ca772-1d3c-45c6-b4af-ce37b2c4a1ec",
    d: "M56.78,21.63H62.5v3.62h3V21.63h5.89a1.21,1.21,0,0,0,1.2-1.21V11.54a1.2,1.2,0,0,0-1.2-1.2H56.78a1.21,1.21,0,0,0-1.21,1.2v8.88A1.21,1.21,0,0,0,56.78,21.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b74ca772-1d3c-45c6-b4af-ce37b2c4a1ec",
    x: 85.56,
    y: 23.98,
    width: 4.2,
    height: 6.32,
    rx: 0.45,
    transform: "translate(24.09 93.32) rotate(-63.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b74ca772-1d3c-45c6-b4af-ce37b2c4a1ec",
    x: 37.71,
    y: 25.04,
    width: 6.32,
    height: 4.2,
    rx: 0.45,
    transform: "translate(-7.83 21.21) rotate(-26.64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOut);
export default __webpack_public_path__ + "static/media/time-out.1061e4bbc2b3dbb6577babbe34e2f059.svg";
export { ForwardRef as ReactComponent };